// Podtemat 2 - przekształcanie wzorów.

import * as FormulaTransform from "./podtemat2_przeksztalcanie_wzorow_types/FormulaTransformOpenTask";
import * as PerimeterFormulaTransform from "./podtemat2_przeksztalcanie_wzorow_types/E8PerimeterFormulaTransformClosedTask";
import * as SumFormula from "./podtemat2_przeksztalcanie_wzorow_types/E8SumFormulaClosedTask";

export const registry = {
  FormulaTransformOpenTask: FormulaTransform,
  E8PerimeterFormulaTransformClosedTask: PerimeterFormulaTransform,
  E8SumFormulaClosedTask: SumFormula,
};

export function generateTasks(options = {}) {
  return [
    FormulaTransform.generateTask({ level: 1 }),
    FormulaTransform.generateTask({ level: 2 }),
    FormulaTransform.generateTask({ level: 3 }),
    PerimeterFormulaTransform.generateTask(options),
    SumFormula.generateTask(options),
  ];
}

function normalizeTask(task) {
  if (registry[task?.type]) return task;

  return {
    type: "FormulaTransformOpenTask",
    data: FormulaTransform.FORMULA_TEMPLATES[0],
    source: { variant: "fallback", replacedType: task?.type || "unknown" },
    tags: ["wzory", "przeksztalcanie_wzorow", "fallback"],
  };
}

function moduleFor(task) {
  const normalized = normalizeTask(task);
  return registry[normalized.type];
}

export function renderTask(task) {
  const normalized = normalizeTask(task);
  return moduleFor(normalized).renderTask(normalized);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  const normalized = normalizeTask(task);
  return moduleFor(normalized).renderInput(normalized, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  const normalized = normalizeTask(task);
  return moduleFor(normalized).checkAnswer(normalized, userAnswer);
}

export function renderAnswer(task) {
  const normalized = normalizeTask(task);
  return moduleFor(normalized).renderAnswer(normalized);
}

export function renderExplanation(task) {
  const normalized = normalizeTask(task);
  return moduleFor(normalized).renderExplanation(normalized);
}

export function renderUserAnswer(userAnswer, task) {
  const normalized = normalizeTask(task);
  return moduleFor(normalized).renderUserAnswer(userAnswer, normalized);
}